<template>
<div class="chapter">
<div class="inner_page">
<p class="dispimg"><img alt="" src="OEBPS/images/pageii.jpg"/></p>
<p class="pagebreak"> </p>
<h1 class="title" id="tp"><strong>In the Lion’s Court</strong></h1>
<p class="subtitle">Power, Ambition, and Sudden Death<br/>in the Reign of Henry VIII</p>
<p class="tp-auth"><strong>Derek Wilson</strong></p>
<p class="pub">St. Martin’s Press   <img alt="" src="OEBPS/images/logo.jpg"/>   New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?02af1a5c